export const DEFAULT_LANGUAGE = 'fa';

export const LANGUAGES = {
    fa: 'fa',
    en: 'en',
};
